// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const AutosStandardWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .AutosStandard {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;

      &-1 {
        max-width: 450px;
        text-align: center;
        margin: auto !important;
      }
    }

    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow > * {
      margin: 0 10px;
    }

    &-title {
      font-size: 1.8em;
      color: #0033a0;
      text-align: left;
      padding-left: .5em;
      margin-top: 20px;
    }

    &-help {
      strong { font-weight: 500; }
      margin: 10px 10px 35px 10px;
      font-size: 14px;
      color: #555;
      text-align: center;
      width: 100%;
    }

    &-checks {
      display: flex;
      padding: 0px 15px;
      flex-direction: row;
    }

    &-options {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      flex-direction: row;

      &-check {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        margin: auto 0;
        padding: 0px 20px;
      }
    }

    @media (max-width: 700px){
      &-options {
        flex-direction: column;
        margin-right: 5%;
      }
    }

    &-option {
      display: grid;
      grid-template-columns: 1fr 2fr;
      align-items: center;
      justify-content: center;
      margin: auto 0;
      padding: 0px 30px;

      &-text {
        margin-right: 20px;
        color: #525252;
      }

      &-check {
        font-size: 16px;
        color: #444;
        display: flex;
        align-items: center;
        margin: 0 20px;

        label {
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        label span {
          padding-right: 10px;
        }
      }
    }

    &-transition {
      transition: opacity .25s ease-in-out;
    }
    &-disabled {
      opacity: .28;
    }

    &-error {
      color: var(--input-error-color);
    }

    &-radioWrapper {
      border: 1px solid rgb(151, 151, 151, .4);
      border-radius: 4px;
      width: 26px;
      height: 26px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      input {
        opacity: 0;
        position: absolute;
      }

      &--on:after {
        content: '';
        display: block;
        width: 5px;
        height: 12px;
        border: solid var(--blue-light-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        top: -1px;
      }
    }
  }

  .overwrite-input {
    text-align: left;
    .input-img-container {
      display: none;
    }
    .ex-text {
      font-size: 1.3em;
      color: #525252;
    }
  }

  .SelectedAnswers {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 10px;
    margin: 20px 0px;
    justify-content: center;
    grid-auto-flow: column;

    &-answerButton {
      padding: 12px;
      font-size: 18px;
      margin: 5px;
      border-radius: 5px;
      white-space: nowrap;
      position: relative;
      cursor: pointer;
      color: var(--white-color);
      background-color: var(--blue-color);
    }

    &-answerCross {
      position: absolute;
      top: 0px;
      font-size: 12px;
    }
  }

  .Price {
    &-withAssistance {
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      padding-top: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #ddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 3px solid #00aec7;
      border-right: 3px solid #0033a0;
      box-shadow: 0 5px 4px 0 rgba(0, 0, 0, 0.11), 0 1px 2px 0 rgba(0, 0, 0, 0.09);
      
      label {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--text-color-2);
        font-size: 14px;
        font-weight: 600;
        margin-left: 8px;
      }
    
      & > div {
        display: flex;
        align-items: center;
      }
    }

    &-icon-check:after {
      content: '';
      display: block;
      width: 5px;
      height: 12px;
      border: solid var(--blue-light-color);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      position: relative;
      top: -1px;
    }

    &-icon-cross {
      position: relative;
      margin: -15px 5px 0 0;
    }

    &-icon-cross:before, .icon-cross:after {
      position: absolute;
      content: ' ';
      height: 16px;
      width: 2px;
      background-color: #666;
    }
    
    &-icon-cross:before {
      transform: rotate(45deg);
    }
    
    &-icon-cross:after {
      transform: rotate(-45deg);
    }

    &-input-radio {
      display: inline-block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      border: 1px solid #ccc;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
      margin-right: .5em;
    }

    &-input-radio--checked:before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      background-color: var(--blue-light-color);
      border-radius: 50%;
    }
  }
`;

export default AutosStandardWrapper;
